import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import DavetliKatilimciService from "../../services/srv-davetli/DavetliKatilimciService";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";

function TicketQrDisplay({ token }) {
  const { t } = useTranslation();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    DavetliKatilimciService.getTicket(token)
      .then((data) => {
        setTicket(data);
        setLoading(false);
      })
      .catch(() => {
        setError(t("ticket_not_found"));
        setLoading(false);
      });
  }, [token]);

  if (loading) return <LoadingPanel />;
  if (error || !ticket) {
    return (
      <div style={{ textAlign: "center", padding: 40 }}>
        <h3>{error || t("ticket_not_found")}</h3>
      </div>
    );
  }

  const qrValue = ticket.qR_TOKEN || ticket.qrToken || token;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(160deg, #f7f9fc 0%, #e8eef5 100%)",
        padding: 24,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          padding: "32px 28px",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0,40,80,0.08)",
        }}
      >
        <img
          src="https://www.daikin.com.tr/Content/img/icons/daikin-logo.svg"
          alt="Daikin"
          style={{ height: 36, marginBottom: 20 }}
        />
        <h2 style={{ margin: "0 0 8px", color: "#003366" }}>
          {ticket.etkinliK_ADI || ticket.etkinlikAdi}
        </h2>
        <p style={{ margin: "0 0 24px", fontSize: 18 }}>
          {ticket.ad} {ticket.soyad ?? ticket.soyaD}
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <QRCodeSVG value={qrValue} size={220} level="M" includeMargin />
        </div>
        <p style={{ margin: "16px 0 0", fontSize: 14, color: "#6c757d" }}>
          {t("total_guest_count")}:{" "}
          {ticket.toplaM_DAVETLI_SAYISI ??
            ticket.TOPLAM_DAVETLI_SAYISI ??
            ticket.toplamDavetliSayisi ??
            "—"}
        </p>
      </div>
    </div>
  );
}

export { TicketQrDisplay };
